// extracted by mini-css-extract-plugin
var _1 = "VerificationModal-module__animateUploadProgressBarWidth--OFHEw";
var _2 = "VerificationModal-module__animatedBackground--kQMJ_";
var _3 = "VerificationModal-module__hr--YnI9C";
var _4 = "VerificationModal-module__notice--owj2m";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "hr", _4 as "notice" }
